/* eslint-disable react/no-unstable-nested-components */
import { ArrowRight, ChartBar } from 'phosphor-react';
import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import { DataGrid } from '../../../components/datagrid';
import { SearchFilter } from '../../../components/inputs/filters/search';
import { PageTitle } from '../../../components/PageTitle';
import { useFetch } from '../../../hooks/useFetch';
import { RowActionButton } from '../../../components/buttons/RowActionButton';
import { getCellStatus } from '../../../utils/FormatFunctions';
import Loader from '../../../components/Loader';
import { useAuth } from '../../../providers/auth';
import { usePageTracking } from '../../../hooks/usePageTracking';
import { AnalyticsModal } from '../../../components/analytics';
import { useAnalytics } from '../../../hooks/useAnalytics';

export function ModulesWeeksPage() {
  const { moduleId } = useParams();
  usePageTracking(`module_${moduleId}_weeks`);

  const [selectedWeek, setSelectedWeek] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/weeks?school_class_id=${moduleId}`;
  const { user } = useAuth();
  const { trackWeekView } = useAnalytics();
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const {
    requestApi: reqApiModule,
    data: dataModule,
    loading: loadingModule,
    error: errorModule,
  } = useFetch('/v1/admin/classes');
  const navigate = useNavigate();

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Nome' },
    { name: 'category.name', label: 'Categoria' },
    { name: 'status', label: 'Status' },
  ];

  useEffect(() => {
    reqApiModule('get', null, `/v1/admin/classes/${moduleId}`);
  }, [moduleId]);

  if (loadingModule) {
    return <Loader />;
  }

  if (errorModule) {
    return (
      <ErrorState onRetry={() => reqApiModule('get', null, `/v1/admin/classes/${moduleId}`)} />
    );
  }
  const groupIds = user?.group?.id;
  const hasAnalyticsAccess = [1, 2, 3, 6, 7].includes(groupIds || 0);

  const handleOpenModal = (weekId: number) => {
    setSelectedWeek(weekId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedWeek(null);
  };

  const handleViewMeetings = (weekId: number) => {
    trackWeekView(weekId);
    navigate(`${weekId}/meetings`);
  };

  return (
    <Box>
      <PageTitle
        description="Semanas que compõem este módulo de conteúdo."
        backTo="/contents/modules"
        backLabel="Módulos"
        currentLabel={dataModule?.data?.name ?? 'Semanas'}
      >
        {dataModule?.data?.name ?? 'Semanas'}
      </PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 7 && groupIds !== 3}
        loading={loading}
        rowActions={{
          show: false,
          edit: groupIds !== 7 && groupIds !== 6,
          delete: groupIds !== 7 && groupIds !== 6 && groupIds !== 3,
        }}
        rowExtraActions={(rowItem: any) => (
          <>
            {hasAnalyticsAccess && (
              <RowActionButton
                label="Estatísticas"
                icon={<ChartBar size={16} />}
                onClick={() => handleOpenModal(rowItem.id)}
              />
            )}
            <RowActionButton
              label="Ver encontros"
              icon={<ArrowRight size={16} />}
              onClick={() => handleViewMeetings(rowItem.id)}
            />
          </>
        )}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />

      {/* Modal de Estatísticas */}
      <AnalyticsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        weekId={selectedWeek || undefined}
        type="week"
      />
    </Box>
  );
}
